mutation addLeadsPipelineStatus($input: AddLeadsPipelineStatusInput!) {
  addLeadsPipelineStatus(input: $input) {
    statuses {
      id
      companyId
      name
      position
    }
    newStatusId
  }
}
